import styled from 'styled-components';

export const Wrapper = styled.div`

`;

export const Container = styled.div`
  
`;

export const CourseTitle = styled.span`
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
`;

export const Footer = styled.div`
  display: grid;
  justify-content: flex-end;
`;

export const Content = styled.div`
  gap: 16px;
  display: grid;
`;

export const Users = styled.div`
  display: grid;
`;

export const User = styled.div`
  gap: 16px;
  align-items: center;
  grid-auto-flow: column;
  grid-template-columns: max-content 1fr max-content;
  display: grid;
  
  border-radius: 5px;
  box-sizing: border-box;
  padding: 11px 14px;
  font-size: 14px;
  
  &:nth-child(2n + 2) {
    background-color: ${({theme}) => `
      ${theme.variables.accentBackgroundColor};
    `};
  }
`;

export const UserAvatar = styled.img`
  border-radius: 50%;
  height: 30px;
  width: 30px;
`;
